import { useSearchParams } from 'next/navigation';

export function usePackagesParams() {
  const searchParams = useSearchParams();
  const eventId = searchParams?.get('eventId');
  const packageType = searchParams?.get('packageType');
  const eventLink = searchParams?.get('eventLink');
  return { eventId, packageType, eventLink };
}
